import classnames from 'classnames';
import { type ComponentProps, forwardRef, type PropsWithChildren } from 'react';
import themeStyles from '../../theme/theme.module.css';
import type { ModerateTheme, NeutralTheme, StrongTheme, SubtleTheme } from '../../types/theme';
import { Text } from '../text/text';
import styles from './chip.module.css';

export type ChipTheme = StrongTheme | ModerateTheme | SubtleTheme | NeutralTheme;

export type ChipProps = PropsWithChildren &
  Omit<ComponentProps<'span'>, 'ref'> & {
    theme?: ChipTheme;
  };

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(({ theme = 'dark', children, ...props }, ref) => (
  <span
    ref={ref}
    {...props}
    className={classnames(
      'chip',
      styles.chip,
      themeStyles[theme],
      Boolean(props.onClick) && styles.clickable,
      props.className,
    )}
  >
    <Text size="xs">{children}</Text>
  </span>
));
